export enum EUrlQueryParams {
  ReturnTo = 'return_to',
  RedirectUrl = 'redirect_url',
  Flow = 'flow',
  Id = 'id',
  AppId = 'app_id',
  Code = 'code',
  Message = 'message',
  InteractiveId = 'interactive-id',
  Callback = 'callback',
  OnChangeCallback = 'on_change_callback',
  IframeUrl = 'iframe-url',
  Amount = 'amount',
  AmountIn = 'amount_in',
  PaymentMethod = 'payment-method',
  Slt = 'slt',
  Slsesid = 'slsesid',
  IsHeaderDisabled = 'isHeaderDisabled',
  Signature = 'signature',
  Redirect = 'redirect',
  Theme = 'theme',
  Language = 'language',
  Title = 'title',
  Transaction = 'transaction',
  PostMessage = 'postMessage',
  Mode = 'mode',
  CryptoMethodGuid = 'crypto_method_guid',
  PaymentCurrency = 'payment_currency',
  CryptoCurrency = 'crypto_currency',
  Country = 'country',
  ShowConfirmWalletOwnership = 'is_show_confirm',
}
